import { render, staticRenderFns } from "./BankPayoutModal.vue?vue&type=template&id=8b60a0f4&scoped=true&"
import script from "./BankPayoutModal.vue?vue&type=script&lang=js&"
export * from "./BankPayoutModal.vue?vue&type=script&lang=js&"
import style0 from "./BankPayoutModal.vue?vue&type=style&index=0&id=8b60a0f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b60a0f4",
  null
  
)

export default component.exports